import Utility from "./utils/utility";
import App from "./app";
import HOME from "./pages/home";
import FORM from "./pages/form";

// ユーティリティクラスのインスタンス化
const UTIL = new Utility();

// テンプレートインスタンス化（promise登録）
const TPL = new App();

// URLによる関数の実行
UTIL.loader( (request, path) => {
  switch( path ){
    case '/': HOME(); break
    case '/recruit': FORM(); break
    case '/contact': FORM(); break
  }
  // switch( request ){}
});


  // (function () {
  //   var wrapper = document.querySelector('.lottie-svg-wrapper');

  //   function reveal() {
  //     // 2フレーム待つことで、SMILタイムラインが
  //     // 確実に最初のtickを終えた状態にしてから表示する
  //     requestAnimationFrame(function () {
  //       requestAnimationFrame(function () {
  //         wrapper.classList.add('is-ready');
  //       });
  //     });
  //   }

  //   if (document.readyState === 'complete') {
  //     reveal();
  //   } else {
  //     window.addEventListener('load', reveal);
  //   }
  // })();

// テンプレートインスタンスの初期化（イベント発火）
TPL.init();